import { Text } from "@next-platform/client-common-spicy-ui";
import { memo } from "react";

// TODO(karlbernard): [NX-11136] Replace with CMS keys (subscription:page.landing.trust*) once registered.
const MEMBERS_LABEL = "members";
const CHARACTERS_LABEL = "characters";
const RATING_LABEL = "avg rating";

type TrustStripProps = {
  readonly members: string;
  readonly characters: string;
  readonly rating: string;
};

function TrustStrip({ members, characters, rating }: TrustStripProps) {
  return (
    <div
      className="flex items-center justify-center gap-4 md:gap-10 px-5 py-[18px] md:py-6 my-6 md:my-10 bg-gray-100 dark:bg-[#101014] rounded-2xl"
      data-testid="TrustStrip"
    >
      <div className="flex flex-1 min-w-0 flex-col items-center gap-[2px] text-center">
        <Text className="md:text-2xl tracking-tight text-gray-900 dark:text-white">{members}</Text>
        <Text className="md:text-[13px] text-gray-600 dark:text-white/50">{MEMBERS_LABEL}</Text>
      </div>

      <div className="w-px h-7 shrink-0 bg-gray-200 dark:bg-white/10" />

      <div className="flex flex-1 min-w-0 flex-col items-center gap-[2px] text-center">
        <Text className="md:text-2xl tracking-tight text-gray-900 dark:text-white">{characters}</Text>
        <Text className="md:text-[13px] text-gray-600 dark:text-white/50">{CHARACTERS_LABEL}</Text>
      </div>

      <div className="w-px h-7 shrink-0 bg-gray-200 dark:bg-white/10" />

      <div className="flex flex-1 min-w-0 flex-col items-center gap-[2px] text-center">
        <Text className="md:text-2xl tracking-tight text-gray-900 dark:text-white">{rating}</Text>
        <Text className="md:text-[13px] text-gray-600 dark:text-white/50">{RATING_LABEL}</Text>
      </div>
    </div>
  );
}

export default memo(TrustStrip);
